export type RequestBundleDisclaimerFound = {
  name: string;
  id: string;
  disclaimer: string;
}

export type RequestBundleDisclaimerNotFound = {
    disclaimer: null;
}

export type BundleDisclaimerResponse = RequestBundleDisclaimerFound | RequestBundleDisclaimerNotFound;


export const LOCAL_STORAGE_SHOWN_BUNDLE_ALERT = 'shown_bundle_alert';